<template>
     <div class="modal fade" id="previewVacancyModal" ref="previewVacEl" tabindex="-1" aria-labelledby="previewVacancyModal-label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title" id="previewVacancyModal-label">Vacancy</div>
          <button class="btn btn-default close-btn" @click="handleClose">
            <CloseIcon style="height: 1.5rem;"/>
          </button>
        </div>
        <div class="modal-body">
          <!-- modal body -->
          <JobPreview :job="preview"
           :update-job-is-saved-status="intermediaryUpdateJobIsSavedStatus"
           :hide-preview-vacancy-modal="intermediaryHideVacancyPreview"/>
        </div>
        <!-- <div class="modal-footer">
        </div> -->
      </div>
    </div>
</div>
</template>
<script>
import JobPreview from '../Jobs/JobPreview.vue';
import CloseIcon from '../IconComponents/CloseIcon.vue';
import { Modal } from 'bootstrap';
export default {
    data(){
        return{
            preview: {
              id:'',
              name:'',
              jobTitle:'',
              location:'',
              closingDate:'',
              description:''
            },
        }
    },
    components:{
        JobPreview, CloseIcon
    },
    props:{
        job: {
          type: Object,
          required: true
        },
        updateJobIsSavedStatus:{
          type: Function,
          required: false
        },
        hideVacancyPreview:{
          type: Function,
          required: false
        }
    },
    watch:{
        job:{
            handler(newValue){
                this.preview = newValue;
            },
            immediate:false,
            deep: true
        }
    },
     mounted() {
        this.modalInstance = new Modal(this.$refs.previewVacEl);
    },
    methods: {
      //links the 'JobPreview' to the 'JobListings' components in functionality
      intermediaryUpdateJobIsSavedStatus(jobItem,isSaved){
          this.updateJobIsSavedStatus(jobItem,isSaved);
      },
      //links the 'JobPreview' to the 'JobListings' components in functionality
      intermediaryHideVacancyPreview(){
        if(this.hideVacancyPreview != null && typeof this.hideVacancyPreview === 'function'){
          this.hideVacancyPreview();
        }
      },
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      }
      ,
      handleClose(){
        // Ensure the modal hides itself first, then call the parent's close handler
        this.hide();
      },
      destroyModal(){
        this.modalInstance = null;
      },
      rebuildModal(){
        this.modalInstance = new Modal(this.$refs.previewVacEl);
      }
    }

}
</script>
<style scoped>
    .modal-title{
        color:var(--page-header);
    }
    .modal-body{
        min-height:500px;
        max-height: 700px;
        overflow-y: auto;        /* vertical scroll */
        overflow-x: hidden; 
        scrollbar-width: thin; 
        scrollbar-color: var(--primary) #f0f0f0;
        margin-bottom:1.4rem;
        padding:0;
    }

    .modal{
        margin-top:-1rem!important;
    }

    .modal-header{
      height:2rem;
      border-bottom:0px;
      padding:1.5rem 0.8rem;
      display: flex;
      justify-content: space-between;
      
    }

    .modal-content{
      border-radius:16px!important;
    }

    .modal-footer{
      height:0.5rem;
      border-top:0px;
    }

    .modal-title{
      height:1rem;
      font-family: var(--heading-font2-regular);
    }

    .close-btn{
      transform:translate(7px,5.3px);
      /* border:1px solid black; */
      padding:0.5rem 0.2rem;
    }

    @media(max-width:768px){
      .modal-header{
        font-size:0.9rem!important;
        
      }

      .modal-title{
        font-size:1.2rem;
        font-family: var(--heading-font2-regular);
      }

    }
</style>